import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import TmAuthSignUpForbiddenError from '@/core/error/transport/auth/TmAuthSignUpForbiddenError'

export const authSignupForbiddenErrorRule: CustomErrorRule = {
  klass: TmAuthSignUpForbiddenError,
  endpoint: EndpointsEnum.registrationAllow,
}
